import actionCreatorFactory from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import { RootState } from "../../state";
import { actionCreatorFactoryForBootstrap } from "../../lib/bootstrap";
import {
  requestToLoadCompanyValueFeatures,
  CompanyValueFeaturesResponse,
  requestToSearchCompanies,
  MatchedCompaniesResponse,
  SearchCompaniesParams,
} from "../api";
import { isFailure } from "../../common/actions/VisitApi";

const actionCreator = actionCreatorFactory("COMPANY_VALUES");
const bootstrapActionCreator = actionCreatorFactoryForBootstrap();

export const loadCompanyValueFeatures = actionCreator.async<RootState, null, CompanyValueFeaturesResponse, Error>(
  "LOAD"
);

export const loadCompanyValueFeaturesWorker = bindThunkAction(loadCompanyValueFeatures, async (_params, dispatch) => {
  const res = await dispatch(requestToLoadCompanyValueFeatures(undefined));
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return res.payload.body;
});

/*
* Actions for values campaign
*/

// '/values'
export const bootstrapValuesIndex = bootstrapActionCreator<MatchedCompaniesResponse>("company_values#index");

export const selectedFeaturesChanged = actionCreator<{ selectedFeatures: number[] }>("SELECTED_FEATURES_CHANGED");

export type loadCompaniesByCompanyValuesParams = Omit<SearchCompaniesParams, "page"> & { nextPage?: boolean };

export const loadCompaniesByCompanyValues = actionCreator.async<
  RootState,
  loadCompaniesByCompanyValuesParams,
  MatchedCompaniesResponse & { page: number },
  Error
>("LOAD_COMPANIES_BY_COMPANY_VALUES");

export const loadCompaniesWorker = bindThunkAction(loadCompaniesByCompanyValues, async (params, dispatch, getState) => {
  const { nextPage, ...restParams } = params;
  const page = nextPage ? getState().company_values.search.page + 1 : 1;
  const res = await dispatch(requestToSearchCompanies({ ...restParams, page }));
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return { ...res.payload.body, page };
});



// WEBPACK FOOTER //
// ./frontend/src/company_values/actions/index.ts